var path = 'src/app/forms/fields/primary-diagnosis-field.html';
var html = "<div primary-diagnosis-selector frm-model frm-required cohort=cohort ng-model=model ng-required=required()></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/primary-diagnosis-field.html
 ** module id = 286
 ** module chunks = 0
 **/